import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

/* ===================== */
/*  TIPOS                */
/* ===================== */

export interface ExcelColumn<T> {
  header: string;
  accessorKey?: string;
  valueGetter?: (row: T) => any;
}

/* ===================== */
/*  HELPERS              */
/* ===================== */

const getNestedValue = (obj: any, path: string): any => {
  return path.split(".").reduce((acc, key) => acc?.[key], obj);
};

/* ===================== */
/*  EXPORT FUNCTION      */
/* ===================== */

export const exportarExcel = <T>(
  data: T[],
  columns: ExcelColumn<T>[],
  fileName: string
) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Datos");

  // Agregar encabezados
  const headers = columns.map((col) => col.header);
  const headerRow = worksheet.addRow(headers);

  // Aplicar negrita al encabezado
  headerRow.font = { bold: true };

  // Llenar datos
  data.forEach((row) => {
    const rowData: any[] = [];
    columns.forEach((col) => {
      if (col.valueGetter) {
        rowData.push(col.valueGetter(row));
      } else if (col.accessorKey) {
        rowData.push(getNestedValue(row, col.accessorKey));
      }
    });
    worksheet.addRow(rowData);
  });

  // Auto ancho de columnas
  columns.forEach((col, index) => {
    const maxLength = Math.max(
      col.header.length,
      ...data.map((row) => {
        let value = "";
        if (col.valueGetter) {
          value = col.valueGetter(row)?.toString() || "";
        } else if (col.accessorKey) {
          value = getNestedValue(row, col.accessorKey)?.toString() || "";
        }
        return value.length;
      })
    );
    worksheet.columns[index].width = maxLength + 2;
  });

  // Generar archivo
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    saveAs(blob, `${fileName}.xlsx`);
  });
};